import { Resolver, ValidationMode } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { promoSchema } from "@/utils/validation/promoSchema";

export const formConfig = {
  resolver: yupResolver(promoSchema) as Resolver<IPromo>,
  mode: "all" as keyof ValidationMode,
  defaultValues: { promo: "" },
};
